import React, { Component } from 'react';

class TravelsFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      manuscript: '*',
      locationType: '*'
    }
  }
  render(){
    const { lines, filterLines } = this.props;
    return (
      <div className="filterSubwayLines">
        <hr/>
        <h3>„МЕДИЙНАТА МРЕЖА ПАИСИАДА“</h3>
        <p></p>
        <label>Изберете ръкопис:</label>
        <select defaultValue="*"
          type="select"
          name="filterlines"
          onChange={(e) => {
            this.setState({
              manuscript:e.target.value
            }, () => filterLines(this.state))
          }}>
            {
              lines.map((line, i) => {
                return (
                    <option value={line} key={i}>{line}</option>
                  );
              }, this)
            }
        </select>
        <br/>
        <label>Тип на местоположението</label>
        <select defaultValue="*" onChange={(e) => {
            this.setState({
              locationType: e.target.value
            }, () => filterLines(this.state))
          }}>
            <option value="*">- Всички типове местоположения: -</option>
            <option value="Място на съставяне">Място на съставяне</option>
            <option value="Място на съхранение">Място на съхранение</option>
            <option value="Временно пребиваване">Временно пребиваване</option>
        </select>
      </div>
    );
  }
}


export default TravelsFilter


// WEBPACK FOOTER //
// ./src/modules/Travels/components/TravelsFilter/index.jsx